import Vue from 'vue'
import App from './App.vue'
// import router from './routerManuaConfig'
import store from './store'
import router from './router/index'
import '../util/global'//全局
import './promissionRouter'//这里进行路由后台获取的模拟
import i18n from './lang' // Internationalization
import Cookies from 'js-cookie'

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import PopupManager from 'element-ui/lib/utils/popup/popup-manager'
import { installUnifiedPagination } from './utils/elPaginationUnify'
import { installTableButtonColumnAutoFit } from './utils/elTableButtonColumnAutoFit'
import { installTableFixedRowSync } from './utils/elTableFixedRowSync'

// 弹窗/抽屉默认挂到 body，避免被分栏 overflow 裁切；遮罩盖住弹窗导致「看得见点不了」。最后修改：2026-08-24
if (ElementUI.Dialog && ElementUI.Dialog.props) {
    if (ElementUI.Dialog.props.appendToBody) {
        ElementUI.Dialog.props.appendToBody.default = true
    }
    if (ElementUI.Dialog.props.modalAppendToBody) {
        ElementUI.Dialog.props.modalAppendToBody.default = true
    }
}
if (ElementUI.Drawer && ElementUI.Drawer.props && ElementUI.Drawer.props.appendToBody) {
    ElementUI.Drawer.props.appendToBody.default = true
}
// 全站表格默认禁止拖拽改列宽（border 表头竖线不可拖）。创建于 2026-08-29
if (ElementUI.TableColumn && ElementUI.TableColumn.props && ElementUI.TableColumn.props.resizable) {
    ElementUI.TableColumn.props.resizable.default = false
}
// 全站表格按钮列按文字宽度自动加宽，须在 Vue.use(ElementUI) 之前注册。创建于 2026-09-27
installTableButtonColumnAutoFit(ElementUI)
// 全站固定列与主表逐行对齐行高，避免主表换行后操作列错位。创建于 2026-09-30
installTableFixedRowSync(ElementUI)

Vue.use(ElementUI, {
    size: Cookies.get('size') || 'medium', // set element-ui default size
    zIndex: 50000, // 高于侧栏抽屉(3000)与历史 mobile-ex(40000)
    i18n: (key, value) => i18n.t(key, value)
});

if (PopupManager) {
    PopupManager.zIndex = 50000
}

// 全站分页统一：每页条数 + 跳转页。最后修改：2026-08-24
installUnifiedPagination(Vue, ElementUI)

// 全站部门树级联：默认只能选班级叶子；options 需配合 prepareDeptCascaderTree。创建于 2026-08-26
import { DEPT_CASCADER_PROPS, DEPT_CASCADER_PROPS_ANY_NODE } from './utils/deptCascaderProps'
Vue.prototype.$deptCascaderProps = DEPT_CASCADER_PROPS
Vue.prototype.$deptCascaderPropsAnyNode = DEPT_CASCADER_PROPS_ANY_NODE

//引用富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
//引入富文本css
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//富文本编辑器添加实例
Vue.use(VueQuillEditor)

Vue.directive('removeAriaHidden', {
    bind(el, binding) {
        const ariaEls = el.querySelectorAll('.el-radio__original')
        ariaEls.forEach((item) => {
            item.removeAttribute('aria-hidden')
        })
    }
})

// 引入图片预览（须高于 ElementUI 弹窗起始 zIndex=50000，否则弹窗内点图会沉底）。最后更新：2026-09-09
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 60000,
        zIndexInline: 60000,
    },
})

//如果想使用 mock ，开启这两行即可，想看效果，看登录页的 mock登录功能
// import Mock from './mock'
// Mock.bootstrap();

import 'font-awesome/css/font-awesome.min.css'

// 引入统一的左右分栏卡片布局全局样式
import './style/split-layout.css'
import './style/meeting-room-theme.css'
import './style/teaching-research-theme.css'
// 开放平台运维控制台统一主题。创建于 2026-08-26
import './style/open-platform-theme.css'
// 全新顶栏（与侧栏同宽品牌区），独立于历史 .header 样式
import './style/app-topbar.css'
// 列表工具栏统一主题。创建于 2026-08-28
import './style/button-theme.css'
import './style/dialog-theme.css'
import './style/quill-editor-theme.css'
import './style/toolbar-theme.css'
import './style/tree-category-name.css'
import './style/category-board.css'
// 手机端适配样式改由 App.vue 在 home.css 之后引入，避免被桌面锁定规则覆盖

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

import './api/http'
import { BaseApiUrl } from './api/base'
import { resolveImageSrc, buildOssUploadData } from './utils/ossMediaUpload'
import {
    parseMediaFilesList,
    prefetchOssMediaFromRows,
    installOssMediaCacheDebugTools,
} from './utils/mediaUrl'
import listOssMediaPrefetchMixin from './mixins/listOssMediaPrefetchMixin'
import deferredImageUploadMixin from './mixins/deferredImageUploadMixin'
import mediaFilesListMixin from './mixins/mediaFilesListMixin'
import exportLoadingMixin from './mixins/exportLoadingMixin'
import ossSrcDirective from './directives/ossSrc'
import OssElImage from './components/OssElImage.vue'
import OssMediaThumbs from './components/OssMediaThumbs.vue'
import OssMediaLink from './components/OssMediaLink.vue'

/** OSS 上传附加 SchId、图片 URL 展示。最后更新：2026-07-01 */
Vue.mixin(listOssMediaPrefetchMixin)
Vue.mixin(deferredImageUploadMixin)
Vue.mixin(mediaFilesListMixin)
Vue.mixin(exportLoadingMixin)
Vue.component('OssElImage', OssElImage)
Vue.component('OssMediaThumbs', OssMediaThumbs)
Vue.component('OssMediaLink', OssMediaLink)
Vue.directive('oss-src', ossSrcDirective)
Vue.prototype.$parseMediaFilesList = parseMediaFilesList
Vue.prototype.$prefetchOssMediaFromRows = prefetchOssMediaFromRows
Vue.prototype.$resolveImageSrc = function (path) {
    return resolveImageSrc(path, this.BaseApiUrl || BaseApiUrl)
}
Vue.prototype.$ossUploadData = function (extra) {
    if (typeof extra === 'string') {
        return buildOssUploadData(this, { Foo: extra })
    }
    return buildOssUploadData(this, extra || {})
}

Vue.config.productionTip = false

installOssMediaCacheDebugTools()

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
